import { render, staticRenderFns } from "./address-section.vue?vue&type=template&id=ed542bee"
import script from "./address-section.vue?vue&type=script&lang=js"
export * from "./address-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports